import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.19331 6.56775L6.67883 5L0 11.9138L6.84543 19L8.32962 17.4636L4.06956 13.0537L24 13.2621L23.9786 11.0671L4.04814 10.8587L8.19331 6.56775Z",
		fill: "currentColor"
	})
});
export default SvgArrowBack;
